<div class="text-center" #paypalRef></div>